import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { faqs } from "../constants/faqs";

const FAQ = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, backgroundColor: "#f8fafc" }}>
      <Container maxWidth="md">
        {/* Header */}
        <Box mb={8}>
          <Typography variant="h3" fontWeight={800} color="primary" gutterBottom>
            Frequently Asked Questions
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.9 }}>
            Find answers to common questions about MySchoolling — our platform,
            features, security, and how to get started.
          </Typography>
        </Box>

        <Divider sx={{ mb: 8 }} />

        {/* FAQ Accordions */}
        <Box>
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
              disableGutters
              elevation={0}
              sx={{
                mb: 2,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: "12px !important",
                "&:before": { display: "none" },
                "&.Mui-expanded": {
                  borderColor: "primary.main",
                  boxShadow: "0 4px 20px rgba(13,27,75,0.08)",
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
                sx={{
                  px: 3,
                  py: 1,
                  borderRadius: "12px",
                  "& .MuiAccordionSummary-content": { my: 1.5 },
                }}
              >
                <Typography fontWeight={600} fontSize="1rem" color="text.primary">
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 3, pb: 3 }}>
                <Typography color="text.secondary" lineHeight={1.9}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

        <Divider sx={{ mt: 8 }} />

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 3 }}
        >
          Still have questions? Contact us at{" "}
          <a href="mailto:support@myschoolling.com">support@myschoolling.com</a>
        </Typography>
      </Container>
    </Box>
  );
};

export default FAQ;
